import { axiosInstance } from '@/plugins/axios';

// 获取项目配置基本api

const setting = {};

/**
 * 获取第三方配置
 * @param key 商家key
 * @author Allen
 */
export const getThridConfig = (key) => {
  let resourceDir = 'thridConfig';
  if (process.env.NODE_ENV === 'production') { // 是否是生产环境
    resourceDir = 'thridConfig_pd';
  }
  const configStr = sessionStorage.getItem(`config_key_${key}`);
  const timestap = new Date().getTime();
  if (configStr !== 'null') {
    return Promise.resolve(JSON.parse(configStr));
  }
  return axiosInstance({
    method: 'get',
    url: `/${resourceDir}/web_${key}.json?timestap=${timestap}`,
    noValidation: true,
  })
    .then(data => data)
    // if (status < 400) {
    //   sessionStorage.setItem(`config_key_${key}`, JSON.stringify(data.data));
    //   return data.data;
    // }
    .catch(() => {
      sessionStorage.setItem(`config_key_${key}`, null);
      return null;
    });
};

/**
 * 获取第三方动态内容
 * @param fileName 文件名
 * @author Allen
 */
export const getContent = fileName => axiosInstance({
  method: 'get',
  url: `/thridConfig/${fileName}.json`,
  noValidation: true,
})
  .then(res => res.data);

/**
 * 获取皮肤
 * @param key 商家key
 * @author Allen
 */
export const getSkins = key => this.getThridConfig(key)
  .then((data) => {
    if (!data) return null;
    return data.skinFileContent;
  });

/**
 * 获取皮肤
 * @param data 请求参数
 */
export const getWebSetting = ({ actionName = 'candao.storeOwn.getWebSetting', ...data }) => axiosInstance({
  method: 'post',
  url: 'Action',
  params: {
    _name: 'getWebSetting',
  },
  data: {
    actionName,
    ...data,
  },
})
  .then((res) => {
    if (res.data) {
      setting.keyId = res.data.keyId;
    }
    return res;
  });

// 获取开放的城市列表
export const cityList = ({ actionName = 'candao.storeStandard.getOpenCityList', ...data }) => axiosInstance({
  method: 'post',
  url: 'Action',
  params: {
    method: 'getOpenCityList',
  },
  data: {
    actionName,
    ...data,
  },
  noValidation: true,
});

// candao.base.getAllCity 获取所有城市列表
export const cityListAll = (actionName = 'candao.base.getAllCity') => axiosInstance({
  method: 'post',
  url: 'Action',
  params: {
    method: 'getOpenCityList',
  },
  data: {
    actionName,
  },
});

export {
  setting,
};

/**
 * 加载皮肤
 * @param key 商家key
 * @param cb 回调函数
 * @author Allen
 */
// export const loadSkin = async (key,cb)=>{
//   let skin = await getSkins(key);
//   if(skin){
//     let style = document.createElement('style');
//     style.innerHTML = skin;
//     document.querySelector('head').appendChild(style);
//     cb && cb();
//   }
// };

/**
 * 加载商户语言包
 * @param {String} key 商户key
 */
// export const configLangLib = async (key) => {
//     let storeInfo = await getThridConfig(key);
//     if(!storeInfo || !storeInfo.langObj) {return;}
//     let langLib = {};
//     Object.keys(storeInfo.langObj.langLib).map(x => {
//         langLib[storeInfo.langObj.langLib[x].zh] = storeInfo.langObj.langLib[x];
//     })
//     Com.Lang.set({langLib:{...langLib},keyLang:true}); // 切换语言，暂时不用这种写法
// }
